module.exports = __webpack_public_path__ + "static/data-diff-819690e97a6ba34c4115885f99b62283.png";